import React from "react";
import grantPermission from "./helpers/grantPermission";

function AuthenticatedContent({ children, roles = [] }) {
  return <>{Array.isArray(roles) && roles.some(role => grantPermission(role)) && children}</>;
}

export default AuthenticatedContent;
